import { DashSourceProfile, TeamPermission } from '@/graphql/generated/types.generated';
import { useTeamPermissions } from '@/providers/team-permissions-provider';
import { DeleteRounded } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteCompetitorDialog from './DeleteCompetitorDialog';

type DeleteCompetitorButtonProps = {
    competitor?: DashSourceProfile;
    competitors?: DashSourceProfile[];
    isGridToolbarButton?: boolean;
};

const DeleteCompetitorButton = ({
    competitor,
    competitors = [],
    isGridToolbarButton,
}: DeleteCompetitorButtonProps) => {
    const { t } = useTranslation();
    const { teamPermissions } = useTeamPermissions();

    const [open, setOpen] = useState(false);

    const hasCrudCompetitorsPerm = teamPermissions.includes(TeamPermission.CrudCompetitors);

    if (!hasCrudCompetitorsPerm) {
        return null;
    }

    return (
        <>
            {isGridToolbarButton ? (
                <Button
                    color="error"
                    startIcon={<DeleteRounded />}
                    onClick={() => setOpen(true)}
                    sx={{ margin: '0 0 0 auto' }}
                >
                    {t('competitor.modal.delete.action.delete')}
                </Button>
            ) : (
                <IconButton color="inherit" onClick={() => setOpen(true)}>
                    <DeleteRounded />
                </IconButton>
            )}

            <DeleteCompetitorDialog
                competitor={competitor}
                competitors={competitors}
                open={open}
                onClose={() => setOpen(false)}
            />
        </>
    );
};
export default DeleteCompetitorButton;
